import { Currency } from "@models/interfaces/currency";
import { Service } from "../base-service";
import { DestructorService } from "@core-services/destructor.service";
import { TranslationService } from "@core-services/translation.service";
import { InitService } from "@core-services/init.service";
import { BpSelectOption } from "@modules/core/components/bp-select/bp-select.component";

export abstract class CurrencyService<M extends Currency> extends Service<M> {
	protected currencyBpOption: BpSelectOption[] = [];

	protected abstract filteredList(): M[];

	public constructor(
		protected initService: InitService,
		protected destructor: DestructorService,
		protected translationService: TranslationService,
		name: string
	) {
		super(initService, destructor, name);

		this._list.subscribe(() => this.updateOptions());
		this.translationService.languageUpdate$().subscribe(() => this.updateOptions());
	}

	public stepSizeByItemId(id: string): number {
		return 1 / Math.pow(10, this.getItemById(id).getPrecision() - 2);
	}

	public stepSizeByItem(item: M): number {
		return this.stepSizeByItemId(item.getId());
	}

	public findBySymbol(s: string): M {
		return this.list.find((c) => c.getSymbol(true) === s.toLocaleLowerCase());
	}

	public findByName(name: string): M {
		return this.list.find((c) => c.getName().toLowerCase() === name.toLocaleLowerCase());
	}

	public getCurrencyAsBpSelectOption(): BpSelectOption[] {
		return this.currencyBpOption;
	}

	protected get language(): string {
		return this.translationService.getLanguage();
	}

	private updateOptions(): void {
		this.currencyBpOption = this.filteredList().map((asset) => ({
			name: asset.getMultiLangField("name", this.language),
			iconUrl: asset.getLogo(),
			value: asset.getId()
		}));
	}
}
